import { createFileRoute } from "@tanstack/react-router";
import { PasswordResetFinalStep } from "@pages/password-reset/password-reset-done/password-reset-done";

export const Route = createFileRoute("/_passwordreset-layout/reset/done")({
  component: PasswordResetFinalStep,
});
